import { render, staticRenderFns } from "./WebDevelopment.vue?vue&type=template&id=53ca1655&"
import script from "./WebDevelopment.vue?vue&type=script&lang=js&"
export * from "./WebDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports